import styled from "styled-components";
export const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.footerBackground};
  width: 100%;
  padding-top: 32px;
  padding-bottom: 48px;
  color: ${({ theme }) => theme.colors.footerText};
  h6 {
    color: ${({ theme }) => theme.colors.footerText};
    margin-bottom: 16px;
  }
  .footer-about {
    font-size: 13px;
    width: 80%;
    text-align: justify;
    .text {
      line-height: 26px;
    }
  }
  .footer-contact {
    font-size: 13px;
    .text {
      line-height: 26px;
    }
  }
  .copyright {
    display: flex;
    align-items: flex-end;
    direction: ltr;
    img {
      height: 136px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .footer-about {
      width: 100%;
    }
  }
  @media only screen and (max-width: 760px) {
    padding-bottom: 32px;
    h6 {
      color: ${({ theme }) => theme.colors.footerText};
      margin-bottom: 8px;
    }
    .footer-about {
      width: 100%;
      margin-bottom: 24px;
    }
    .footer-contact {
      margin-bottom: 24px;
    }
  }
`;
